module.exports = __webpack_public_path__ + "static/img/he-top.9510e04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/he-top.png
// module id = 4BGX
// module chunks = 0